/* -------------------------------------------------------------------------- */
/* ESSENTIAL INITIALIZATION                                                   */
/* -------------------------------------------------------------------------- */

import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueWait from 'vue-wait';
import Toast from 'vue-toastification';
import toastConfig from '@/configs/toast';
import '@components/RegisterComponents.ts';
import '@rogues/RegisterRogues.ts';
import '@nodes/mixins/Global';
import '@nodes/mixins/Theme';
import router from '@nodes/router';
import Settings from '@nodes/settings';
import Configs, { configs } from '@nodes/configs';
import Services from '@nodes/services';
import store from '@nodes/store';
import i18n from '@nodes/locales';
import VueScrollTo from 'vue-scrollto';
import VueMq from 'vue-mq';
// %import%

// Import core and theme styles
import '@/assets/scss/Style.scss';
import 'vue-toastification/dist/index.css';

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});
Vue.use(VueWait);
Vue.use(Toast, toastConfig);
Vue.use(Settings);
Vue.use(Configs);
Vue.use(Services);
Vue.use(VueScrollTo);
Vue.use(VueMq);
// %use%

const wait = new VueWait();
const coreInitiate = {
    router,
    store,
    wait,
    i18n,
    // %register%
};

export default coreInitiate;
